import layouts from '../../layouts/layouts'
import base from '../dr-base'
import drPage from './dr-page.vue'

const schema =  {
  ...base,
  allowInToolbox: false,
  $Type: 'dr-page',
  name: 'Page',
  group: 'Container widgets',
  icon: 'link',
  properties: {
    Name: {
      name: 'vuetifyWidgets.dr-page.name',
      type: 'string',
      default: 'Main'
    },
    Class: {
      name: 'vuetifyWidgets.dr-base.cssClass',
      type: 'string'
    },
    LayoutType: {
      name: 'vuetifyWidgets.dr-page.layoutType',
      type: 'string',
      default: 'responsive',
      enum: [
        { text: 'Responsive', value: 'responsive' },
        { text: 'Pop-Up', value: 'popup' },
        { text: 'Modal Pop-Up', value: 'modalPopup' }
      ]
    },

    Disabled: {
      name: 'vuetifyWidgets.dr-page.disablePage',
      type: 'object',
      component: 'dr-prop-action',
      properties: { 
        Type: {
          name: 'vuetifyWidgets.drPropAction.type',
          type: 'string',
          enum: [
            {
              value: 'RunJsAction',
              text: 'vuetifyWidgets.drPropAction.runJsAction'
            }
          ]
        },
        Parameters: {
          name: 'vuetifyWidgets.drPropAction.dictionaryParameter',
          type: 'string'
        },
        LoadIndicator: {
          name: 'vuetifyWidgets.drPropAction.loadIndicator',
          type: 'string',
          enum: [
            {
              value: 'noIndicator',
              text: 'vuetifyWidgets.drPropAction.noIndicator'
            },
            {
              value: 'nonBlockingUI',
              text: 'vuetifyWidgets.drPropAction.nonBlockingUI'
            },
            {
              value: 'blockingUI',
              text: 'vuetifyWidgets.drPropAction.blockingUI'
            }
          ]
        },
        LoadIndicatorText: {
          name: 'vuetifyWidgets.drPropAction.loadIndicatorText',
          type: 'string'
        }
      }
    },

    OnClosePage: {
      name: 'vuetifyWidgets.dr-page.pageCloseEvent',
      type: 'object',
      component: 'dr-prop-action',
      properties: { 
        Type: {
          name: 'vuetifyWidgets.drPropAction.type',
          type: 'string',
          enum: [
            {
              value: 'RunJsAction',
              text: 'vuetifyWidgets.drPropAction.runJsAction'
            }
          ]
        },
        Parameters: {
          name: 'vuetifyWidgets.drPropAction.dictionaryParameter',
          type: 'string'
        },
        LoadIndicator: {
          name: 'vuetifyWidgets.drPropAction.loadIndicator',
          type: 'string',
          enum: [
            {
              value: 'noIndicator',
              text: 'vuetifyWidgets.drPropAction.noIndicator'
            },
            {
              value: 'nonBlockingUI',
              text: 'vuetifyWidgets.drPropAction.nonBlockingUI'
            },
            {
              value: 'blockingUI',
              text: 'vuetifyWidgets.drPropAction.blockingUI'
            }
          ]
        },
        LoadIndicatorText: {
          name: 'vuetifyWidgets.drPropAction.loadIndicatorText',
          type: 'string'
        }
      }
    },

    Layout: {
      computed(params) {
        let { selectedWidget } = params
        let layoutType = selectedWidget.LayoutType === undefined ? 'responsive' : selectedWidget.LayoutType
        let filteredLayouts = layouts.filter(x => x.LayoutType.includes(layoutType))
        return filteredLayouts.map(x => ({
          value: x.$ID,
          text: x.Name
        }))
      },

      onSetValue(params) {
        let { selectedWidget, newValue } = params
        if (selectedWidget.LayoutType) {
          return
        }
        selectedWidget.LayoutType = layouts.find(x => x.value == newValue.value).LayoutType[0]
      },

      name: 'Layout',
      type: 'string',
      enum: []
    },
    PopPupTitle: {
      name: 'PopPupTitle',
      type: 'string',
      default: ''
    },
    Path: {
      name: 'Path',
      type: 'string',
      default: ''
    },
    Width: {
      name: 'vuetifyWidgets.dr-page.width',
      type: 'string',
      default: ''
    },
    AllowedRoles: {
      onCreate(that) {
        let systemRoles = that.$store.state.appModels.model.ProjectSecurity.UserRoles

        let userRoles = []
        if (that.$store.state.appModels && that.$store.state.appModels.changedModel && that.$store.state.appModels.changedModel.ProjectSecurity && that.$store.state.appModels.changedModel.ProjectSecurity.UserRoles) {
          userRoles = that.$store.state.appModels.changedModel.ProjectSecurity.UserRoles
        }

        this.items = [...systemRoles, ...userRoles]
      },
      name: 'vuetifyWidgets.dr-page.roles',
      type: 'multiple-select',
      items: [],
      selectedItems: []
    },
    CheckAvailability: {
      name: 'vuetifyWidgets.dr-page.checkAvailability',
      type: 'boolean'
    },
    MakeOverlayTransparent: {
      name: 'vuetifyWidgets.dr-page.makeOverlayTransparent',
      type: 'boolean'
    },
    HidePageOnLoad: {
      name: 'vuetifyWidgets.dr-page.hidePageOnLoad',
      type: 'boolean'
    },
    ForceOidcLogin: {
      name: 'vuetifyWidgets.dr-page.forceOidcLogin',
      type: 'boolean'
    },
    FullScreenType: {
      name: 'vuetifyWidgets.dr-page.fullScreenType',
      type: 'string',
      default: 'disabled',
      enum: [
        { text: 'Disabled', value: 'disabled' },
        { text: 'Maximized', value: 'maximized' },
        { text: 'Minimized', value: 'minimized' }
      ]
    }
  }
}

export default {
  schema,
  component: drPage
}
